let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ejKF4")).then(() => parcelRequire('9PYsD'));